import React, { useEffect, useState } from "react";
import testwrap from 'assets/icons/brain.png'
import { getSurveyData } from "service/SurveyService";
import closeicon from 'assets/icons/lock.png'
import openicon from 'assets/icons/unlock.png'
import styles from "./SurveyBody.module.scss";
import moment from 'moment';
import { useNavigate } from 'react-router-dom'
const SurveyBody = ({ data, isadmin, log=null }) => {
  const navigate = useNavigate()
 
  const [render, setRender] = useState(false)


  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });

  useEffect(() => {

    setRender(false)

  }, [render]);

  const handleClick = (id) => {
    // Ensure that the navigation happens only on a button click
    if (typeof id !== "undefined") {
      navigate(`/survey/`, { state: { usedId: id } });
    }
  };
  const handleClickSurvey = (id) => {
    // Ensure that the navigation happens only on a button click
    if (typeof id !== "undefined") {
      navigate(`/usesurvey/`, { state: { usedId: id } });
    }
  };

  const formatDate = (dateString) => {
    const date = moment(dateString, 'DD.MM.YYYY HH:mm');
    const today = moment();

    if (date.isSame(today, 'day')) {
      return date.format('Сегодня HH:mm');
    }
    else if (date.isSame(today, 'year')) {
      return date.format('DD MMMM HH:mm')
    }
    else {
      return date.format('DD MMMM YYYY HH:mm');
    }
  };

  return (
    <>
      <div className={styles.test_card_wrapper}>
        {(log === 0) ? (
          <>
            {[...data].map((item) => {
              return (
                <div className={styles.test_card}>
                  <div className={styles.header_div_set}>


                    <div style={{ width: '100%', maxWidth: '100%', overflowWrap: 'break-word', wordWrap: 'break-word', whiteSpace: 'pre-wrap' }}>
                      <p className={styles.title_test}><img src={testwrap} className={styles.img} alt="" ></img>{item.employee_part_survey_title}</p>

                      <pre style={{ whiteSpace: 'pre-wrap', fontSize: '14px' }} >{item.description}</pre>
                    </div>
           
                  </div>
                  <div className={styles.date_footer_div_second}>



                    <div className={styles.date_footer_div}>
                      <div className={styles.user_avatar}>
                        {/* <img
                  src={item?.image}
                  
                  alt="avatar"
                  style={{ cursor: "pointer" }}
                  className={styles.user_avatar_img}
                />{" "} */}
                        <p className={styles.date_footer_employee_info}>
                          {" "}

                        От {item.employee_name}
                        </p>
                      </div>

                      <p className={styles.date_footer}>
                        {" "}

                        Потрачено времени: {item.time_response}
                      </p>
                    </div>
                    <div className={styles.bottom_footer_button}>
                   
                        <button className={styles.open_btn} onClick={() => handleClickSurvey(item.survey)}>
                          Просмотреть
                        </button>
                     

                    </div>
                  </div>
                </div>
              );
            })}
          </>
        ) : ( <>
          {[...data].map((item) => {
            return (
              <div className={styles.test_card}>
                <div className={styles.header_div_set}>

              
                  <div style={{ width: '100%', maxWidth: '100%', overflowWrap: 'break-word', wordWrap: 'break-word', whiteSpace: 'pre-wrap' }}>
                    <p className={styles.title_test}><img src={testwrap} className={styles.img} alt="" ></img>{item.title}</p>

                    <pre style={{ whiteSpace: 'pre-wrap', fontSize: '14px' }} >{item.description}</pre>
                  </div>
                  <p className={styles.title_test}>

                    <img
                      src={item.activate ? openicon : closeicon}
                      className={styles.img_status}
                      alt={item.activate ? "Открыт" : "Закрыт"}
                    />
                    {item.activate ? "Открыт" : "Закрыт"}
                  </p>
                </div>
                <div className={styles.date_footer_div_second}>



                  <div className={styles.date_footer_div}>
                    <div className={styles.user_avatar}>
                      {/* <img
                  src={item?.image}
                  
                  alt="avatar"
                  style={{ cursor: "pointer" }}
                  className={styles.user_avatar_img}
                />{" "} */}
                      <p className={styles.date_footer_employee_info}>
                        {" "}

                        {item.employee_name}
                      </p>
                    </div>

                    <p className={styles.date_footer}>
                      {" "}

                      {formatDate(item.createdAt)}
                    </p>
                  </div>
                  <div className={styles.bottom_footer_button}>
                    {isadmin ? (
                      item.employee_name && (
                        <button className={styles.open_btn} onClick={() => handleClick(item.id)}>
                          Смотреть
                        </button>
                      )
                    ) : (
                      <button className={styles.open_btn} onClick={() => handleClickSurvey(item.id)}>
                        Пройти
                      </button>
                    )}

                  </div>
                </div>
              </div>
            );
          })}
        </>)}



      </div>
    </>
  )
};

export default SurveyBody;
